export default class DataExtraServiceDetails {
}
DataExtraServiceDetails.TableHeaders = [
    {
        text: "ID",
        value: "bss_details_id",
    },
    {
        text: "Option name (BSS)",
        value: "bss_details_title",
    },
    {
        text: "Display name",
        value: "name_en",
    },
    {
        text: "Price (BSS)",
        value: "bss_details_price",
    },
    {
        text: "Edit",
        value: "action",
    },
];
